import { ChangeHistoryTwoTone, Circle, Rectangle } from '@mui/icons-material';
import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SmallGrid } from '~/components/inputs/MediaSelect';
import { useStudio } from '../../context';
import {
  StudioShapeButton,
  StudioSidebarContainer,
  StudioSidebarTitle,
  useAddStudioItems,
} from '../lib';
import { StudioSettings } from './';

export const StudioSidebar = () => {
  const { t } = useTranslation();
  const { activeSidebarItem } = useStudio();
  const { addBodyText, addCircle, addHeading, addMedia, addRectangle, addSubheading, addTriangle } =
    useAddStudioItems();

  return (
    <StudioSidebarContainer>
      {activeSidebarItem === 'Text' && (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, padding: 2 }}>
          <StudioSidebarTitle>{t('pages.studio.edit.sidebar.text.title')}</StudioSidebarTitle>
          <Button onClick={addHeading} variant="outlined">
            <Typography variant="h5" sx={{ fontWeight: 800 }}>
              {t('pages.studio.edit.sidebar.text.add_heading')}
            </Typography>
          </Button>
          <Button onClick={addSubheading} variant="outlined">
            <Typography variant="h5">
              {t('pages.studio.edit.sidebar.text.add_subheading')}
            </Typography>
          </Button>
          <Button onClick={addBodyText} variant="outlined">
            <Typography variant="body1">
              {t('pages.studio.edit.sidebar.text.add_body_text')}
            </Typography>
          </Button>
        </Box>
      )}
      {activeSidebarItem === 'Media' && (
        // No POWERPOINT: both insert and reload read originalFile.uri, which
        // for a deck is the .pptx, not the mp4 rendition. Studio has to read
        // the servable file (MediaItem#file) before decks can be listed here.
        <SmallGrid
          kind={['IMAGE', 'VIDEO']}
          storageContext="studio"
          onClick={addMedia}
          rememberLastFolder
        />
      )}
      {activeSidebarItem === 'Shapes' && (
        <>
          <Box sx={{ display: 'flex' }}>
            <StudioShapeButton onClick={addRectangle}>
              <Rectangle />
            </StudioShapeButton>
            <StudioShapeButton onClick={addCircle}>
              <Circle />
            </StudioShapeButton>
          </Box>
          <Box sx={{ display: 'flex' }}>
            <StudioShapeButton onClick={addTriangle}>
              <ChangeHistoryTwoTone
                sx={{
                  'path:first-of-type': {
                    opacity: 1,
                    transform: 'scale(1.1) translate(-1px, -1px)',
                  },
                }}
              />
            </StudioShapeButton>
          </Box>
        </>
      )}
      {activeSidebarItem === 'Settings' && <StudioSettings />}
    </StudioSidebarContainer>
  );
};
